export default __webpack_public_path__ + "static/project-slide-1-4032-2268-4b3a01ab286686e176283eade9b6d3c1.jpg";